<script>
    import classnames from 'classnames';
    import I18n from '@js/modules/translations';

    const {
        class: className
    } = $props();

    const surfaceGroups = [
        {key: 'paved', color: '#616161'},
        {key: 'compacted', color: '#FF9800'},
        {key: 'gravel', color: '#FFC107'},
        {key: 'dirt', color: '#8D6E63'},
        {key: 'natural', color: '#66BB6A'},
        {key: 'unknown', color: '#9E9E9E'}
    ];
</script>

<div class={classnames('map-surface-legend', className)}>
    <div class="surface-legend-title">
        {I18n.t('js.maps.toolbar.surface_color.legend_title')}
    </div>

    <div class="surface-legend-items">
        {#each surfaceGroups as group (group.key)}
            <div class="surface-legend-item">
                <span class="surface-legend-color"
                      style="background-color: {group.color}"></span>
                <span class="surface-legend-label">
                    {I18n.t(`js.maps.toolbar.surface_color.types.${group.key}`)}
                </span>
            </div>
        {/each}
    </div>
</div>
